import { render } from "./tekraraedenisCard.vue?vue&type=template&id=2dc38a93"
import script from "./tekraraedenisCard.vue?vue&type=script&lang=js"
export * from "./tekraraedenisCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__